import React from "react";
import PlanIcon from "assets/images/icons/plan.png";
import { pricingData, estimationPackages } from "components/LandingPageTemplateComponents/Pricing/PricingComponentData";

// Plans are priced per licence — one price, bought in whatever quantity the
// company needs — so this reads the same tier list the pricing page does
// instead of hardcoding prices and seat allowances of its own.
export default function Plan() {
  return (
    <div className="w-100">
      <div className="w-75 py-4 px-2">
        <p className="font-weight-bold text-black mb-1 h3">Plan</p>
        <p>
          The plans BidLight sells, as on bidlight.com. To change your plan or
          add an estimation package, buy on the pricing page with your company
          email or contact support@bidlight.com.
        </p>
        <hr />

        {/* Coordination plans first, then the estimation packages - the same
            two lists as bidlight.com/pricing and /estimation. */}
        {[
          { heading: "Coordination plans", plans: pricingData },
          { heading: "Estimation packages", plans: estimationPackages },
        ].map((section) => (
          <React.Fragment key={section.heading}>
            <p className="font-weight-bold text-black mt-4 mb-1 h5">{section.heading}</p>
            {section.plans.map((plan, index) => (
              <div
                className={index === 0 ? "plan-container mt-3" : "plan-container mt-3"}
                key={`${section.heading}-${plan.title}`}
              >
                <div className="plan-header">
                  <div className="d-flex align-items-center">
                    <img src={PlanIcon} alt="" />
                    <p>{plan.title}</p>
                  </div>
                </div>
                <div className="plan-content">
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="price">
                      {plan.flat ? (
                        <>
                          ${plan.monthly.toLocaleString()} <span>per month, unlimited licences</span>
                        </>
                      ) : plan.amount === null ? (
                        "Contact us"
                      ) : (
                        <>
                          ${plan.amount.toLocaleString()} <span>per licence, billed annually</span>
                          {plan.monthly ? <span> · ${plan.monthly} per licence, per month</span> : null}
                        </>
                      )}
                    </p>
                  </div>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: plan.description,
                    }}
                  />
                  {Array.isArray(plan.points) && plan.points.length ? (
                    <ul className="mb-0 pl-3">
                      {plan.points.map((pt) => (
                        <li key={pt}>{pt}</li>
                      ))}
                    </ul>
                  ) : null}
                </div>
              </div>
            ))}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
